
export default function ProcessSection() {
  const steps = [
    {
      number: '01',
      title: 'Solicita Tasación',
      description: 'Rellena el formulario con los datos de tu vehículo. Es rápido y sin compromiso.'
    },
    {
      number: '02',
      title: 'Recibe Oferta',
      description: 'En menos de 24 horas te enviamos una oferta competitiva por tu coche.'
    },
    {
      number: '03',
      title: 'Recogida Gratis',
      description: 'Acordamos día y hora. Vamos a recoger tu vehículo sin coste adicional.'
    },
    {
      number: '04',
      title: 'Pago Inmediato',
      description: 'Recibes el pago al momento. Transferencia o efectivo, tú decides.'
    }
  ];

  return (
    <section id="proceso" className="py-24 bg-[#f8f9fa]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
          <div className="lg:col-span-5">
            <h2 className="text-4xl lg:text-5xl font-black text-[#1a2332] mb-6 leading-tight">
              Vender Tu Coche<br />
              Nunca Fue Tan Fácil
            </h2>
            <p className="text-lg text-gray-600 leading-relaxed mb-8">
              En Desguace Barcelona hemos simplificado todo el proceso para que vendas tu coche de forma rápida, segura y al mejor precio del mercado.
            </p>
            <a 
              href="#tasacion" 
              className="inline-flex items-center px-8 py-4 border-2 border-[#1a2332] text-[#1a2332] rounded-full font-bold hover:bg-[#1a2332] hover:text-white transition-all whitespace-nowrap cursor-pointer"
            >
              Ver proceso completo
              <i className="ri-arrow-right-line ml-2"></i>
            </a>
          </div>

          <div className="lg:col-span-7">
            <div className="relative">
              <div className="absolute left-8 top-12 bottom-12 w-0.5 bg-gradient-to-b from-[#1a2332] via-[#1a2332]/50 to-[#1a2332] hidden md:block" style={{ backgroundImage: 'repeating-linear-gradient(0deg, #1a2332, #1a2332 10px, transparent 10px, transparent 20px)' }}></div>
              
              <div className="space-y-10">
                {steps.map((step, index) => (
                  <div key={index} className="flex items-start gap-6">
                    <div className="flex-shrink-0 w-16 h-16 bg-gradient-to-br from-[#1a2332] to-[#2d3e50] rounded-full flex items-center justify-center text-white font-black text-xl shadow-lg">
                      {step.number}
                    </div>
                    <div className="flex-1 pt-2">
                      <h3 className="text-2xl font-bold text-[#1a2332] mb-2">{step.title}</h3>
                      <p className="text-base text-gray-600 leading-relaxed">{step.description}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
